import AdminDashboard from './admin/AdminDashboard';

export default function Admin() {
  return <AdminDashboard />;
}